// extracted by mini-css-extract-plugin
module.exports = {"container":"Amendements_container__1wPwF","list":"Amendements_list__2Ls_4","row":"Amendements_row__2GOFu","col":"Amendements_col__vhlKq","date":"Amendements_date__1k4G5"};